import { motion } from "framer-motion";
import { StarIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
const testimonials = [{
  text: "Después de aplicar el checklist antes de aprobar mis planificaciones, reduje varios refinamientos que antes consideraba inevitables. Hoy tomo decisiones con mucha más seguridad.",
  name: "Dr. Andrés R.",
  role: "Ortodoncista",
  country: "Colombia 🇨🇴",
  img: "https://cdn.magicpatterns.com/patterns/generated-images/91ca31cd-b71d-46b7-b24e-7062dedc9929.jpg"
}, {
  text: "Los protocolos son extremadamente claros. Es como tener a un especialista revisando cada caso contigo antes de aprobarlo.",
  name: "Dra. Fernanda G.",
  role: "Odontóloga",
  country: "México 🇲🇽",
  img: "https://cdn.magicpatterns.com/patterns/generated-images/a9681767-6fa8-497d-8199-9e51ef952b71.jpg"
}, {
  text: "El Tomo sobre torque y movimiento radicular cambió completamente mi forma de planificar tratamientos con alineadores. Muy recomendado.",
  name: "Dr. Sebastián M.",
  role: "Ortodoncista",
  country: "Chile 🇨🇱",
  img: "https://cdn.magicpatterns.com/patterns/generated-images/91ec08cf-a77b-44a6-818b-a2d64fd63615.jpg"
}, {
  text: "Lo que más me gustó fue que todo está orientado a la práctica clínica. No pierdes tiempo leyendo teoría innecesaria.",
  name: "Dr. Luis A.",
  role: "Odontólogo General",
  country: "Perú 🇵🇪",
  img: "https://cdn.magicpatterns.com/patterns/generated-images/29edbd34-5422-44b4-b5b3-13d03f51c5bc.jpg"
}];
export function Testimonials() {
  return <section className="w-full bg-slate-50 py-14 sm:py-20" data-id="element-211" data-mp="q7648ozu3zu0">
      <div className="mx-auto max-w-lg px-5 sm:max-w-3xl lg:max-w-5xl" data-id="element-212" data-mp="q4jwopcy1kbs">
        <SectionHeading eyebrow="Testimonios" title="Lo que opinan otros profesionales" data-id="element-213" data-mp="v4em0oh2m1uq" />

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-214" data-mp="1itz65aoyn55l">
          {testimonials.map((t, i) => <motion.div key={t.name} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: i % 2 * 0.08
        }} className="flex flex-col rounded-2xl border border-slate-100 bg-white p-5 shadow-sm sm:p-6" data-id="element-215" data-mp="1nnbo51z4wdpd" data-mpi={i}>
              <div className="flex gap-0.5 text-[#f5a623]" data-id="element-216" data-mp="1jhg5agbbc467">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-current" data-id="element-217" data-mp="1ekg1kc1xrdi9" data-mpi={s} />)}
              </div>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600 sm:text-[15px]" data-id="element-218" data-mp="19qbt1od0uxf2">
                “{t.text}”
              </p>
              <div className="mt-4 flex items-center gap-3 border-t border-slate-100 pt-4" data-id="element-219" data-mp="10sj9g809p3lv">
                <img src={t.img} alt={t.name} className="h-12 w-12 rounded-full object-cover ring-2 ring-[#1e88e5]/20" data-id="element-220" data-mp="vt6m7m5hhuir" />
                <div data-id="element-221" data-mp="32h5w28exotkr">
                  <p className="font-head text-sm font-800 text-[#0f2547]" data-id="element-222" data-mp="32fuijgvos7gg">
                    {t.name}
                  </p>
                  <p className="text-xs text-slate-500" data-id="element-223" data-mp="37efn1shz1dap">
                    {t.role} — {t.country}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}